/**
 * 课程管控类型，0-弱管控，1-强管控
 */
export const COURSE_CONTROL_TYPE = {
    WEAK: 0,
    FORCE: 1,
};

/**
 * VSS账户类型：目前有2种账户类型，0: 商品供应商账户，1: 劳动力供应商账户。 一个账号可以同时拥有 2 个账户类型。
 */
export const VSS_ACCOUNT_TYPE = [
    {
        label: '商品供应协同平台',
        code: 0,
        to: '/index.html',
    },
    {
        label: '劳动力协同平台',
        code: 1,
        to: '/renxiao/index.html',
    },
];

/**
 * S3 桶名常量
 */
export const BUCKET_NAME = {
    PRIVATE: 'gongji-fe-private-files',
    PUBLIC: 'gongji-fe-public-files',
};

/**
 * 私有桶上传参数（函数形式，确保 expireTime 在组件初始化时动态生成，有效期 6 个月）
 */
export const getPrivateUploadData = () => ({
    bucketName: BUCKET_NAME.PRIVATE,
    expireTime: (() => {
        const now = new Date();
        now.setMonth(now.getMonth() + 6);
        return now.getTime();
    })(),
});

/**
 * 公有桶上传参数
 */
export const getPublicUploadData = () => ({
    bucketName: BUCKET_NAME.PUBLIC,
});

/**
 * 美团大学各环境链接
 */
export const SCHOOL_HOST = (() => {
    if (process.env.NODE_ENV === 'production') {
        return 'https://daxue.meituan.com';
    } else if (process.env.NODE_ENV === 'staging') {
        return 'https://mtdx.cap.st.meituan.com';
    } else {
        return 'https://mtdx.cap.test.sankuai.com';
    }
})();
